import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://mylife.mobijalski.pl/api',
  apiBaseUrl: 'https://mylife.mobijalski.pl',
  appName: 'MyLife',
  appUrl: 'https://mylife.mobijalski.pl',
  assetsUrl: '/frontend/assets'
};
